import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../entity/grid/column.component";
import {AbstractColumnComponent} from "../../../entity/grid/abstract-column.component";

@Component({
    selector: "wbo-numeric-column",
    templateUrl: "./numeric-column.component.html",
    styleUrls: ["./numeric-column.component.scss"],
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => NumericColumnComponent), multi: true}
    ]
})
export class NumericColumnComponent extends AbstractColumnComponent {
    @Input() format: string;
    @Input() notation: string;
    @Input() showPlaceholderForCell: boolean;
    @Input() emptyIfZero;

    constructor(injector: Injector) {
        super(injector);
    }

    isEmpty(value: number): boolean {
        return value == null || (this.emptyIfZero && value === 0);
    }
}
